<template>
    <div class="flex items-center justify-center w-full">
        <div class="flex flex-col gap-4 w-full max-w-[500px]">
            <h1 class="text-2xl font-bold">Forgot Password</h1>
            <FormKit type="form" @submit="submit" :actions="false">
                <FormKit
                    type="email"
                    name="username"
                    label="Username"
                    v-model="form.username"
                />
                <FormKit type="submit" label="Reset Password" />
            </FormKit>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { usePage, router } from "@inertiajs/vue3";
import { FormKit } from "@formkit/vue";

const form = ref({
    username: "",
    _csrfToken: usePage().props._csrfToken,
});

const submit = () => {
    router.post("/forgot-password", form.value, {
        headers: {
            "X-CSRF-Token": usePage().props._csrfToken,
        },
    });
};
</script>
